// Errors in the browser are sent to Books (books_api.log_client_error, at most 30 an hour a person) so they are seen
// before anyone writes in. Nothing typed in a form is sent: the message, where it happened, the page and the browser.
import { accountApi } from "./api";

let sent = 0;
export function reportErrors() {
  const send = (message: string, detail?: string) => {
    if (sent++ > 20 || /ResizeObserver loop|Script error\.?$/.test(message)) return;
    const company = (() => { try { return sessionStorage.getItem("books.lastCompany"); } catch { return null; } })();
    void accountApi.logError({ page: location.pathname, message: message.slice(0, 1000), detail: detail?.slice(0, 4000), agent: navigator.userAgent, company }).catch(() => undefined);
  };
  window.addEventListener("error", (e) => send(e.message, e.error?.stack));
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason as { message?: string; stack?: string; code?: string } | undefined;
    if (r?.code) return;   // the API's own refusals are shown to the person, not errors
    send(r?.message ?? String(e.reason), r?.stack);
  });
}
